const cancel = 'Otkaži'
const save = 'Sačuvaj'

export default {

  global: {
    generalError: 'Greška! Zahtev nije obrađen. Ponovo učitajte stranicu.',
    signature: 'Srdačan pozdrav,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'Dodati biografiju ili ostale priloge',
      placeholderWithDescription: 'Dodajte zatražene priloge',
      remove: 'Ukloni',
      allowedFileTypes: 'Dozvoljeni tipovi datoteka',
      errors: {
        size: 'Fajl je prevelik, maksimalna veličina za fajl je 5MB',
        empty: 'Datoteka ne sadrži podatke',
        invalidType: fileType => `Nažalost, datoteke ${fileType} nisu dozvoljene iz bezbednosnih razloga`,
        typeNotWhitelisted: 'Nažalost, tip datoteke nije dozvoljen.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Politika privatnosti',
      termsLinkText: 'Uslove i odredbe',
      privacyPolicyText: 'Cenimo vašu privatnost, pročitajte našu ',
      termsText1: 'Pročitajte i prihvatite ',
      termsText2: 'pre nego što nam dostavite svoje podatke o ličnosti.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Ukoliko ne želite da obradimo vaše lične podatke, možete tražiti da ih uklonimo tako što ćete poslati poruku na ${mail}.`,
      customSupportPrivacyInfo: link => `Ako ne želite da obrađujemo vaše podatke o ličnosti, možete zatražiti njihovo uklanjanje tako što ćete nam se obratiti na adresu ${link}.`,
    },

    buttons: {
      close: 'Zatvori',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Ukloni pokušaj',
      confirm: 'Pokušajte ponovo',
    },

    confirmButton: {
      wait: count => `Sačekajte ${count}`,
      confirm: 'Potvrdite',
    },

    controlStatus: {
      text: {
        empty: 'Popunite',
        valid: () => 'Spremno',
      },
      textarea: {
        empty: 'Popunite',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Postavi',
        valid: () => 'Spremno',
      },
      file: {
        empty: 'Odaberi',
        valid: () => 'Promeni',
      },
      list: {
        empty: 'Dodaj',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Pretraži',
        valid: () => 'Spremno',
      },
    },

    cookieConsentModal: {
      title: 'Naš sajt koristi kolačiće',
      body: 'Ako prihvatite sve kolačiće, saglasni ste sa skladištenjem kolačića na vašem uređaju radi poboljšanja navigacije sajta, analize upotrebe sajta i pružanja pomoći našim marketinškim naporima.',
      learnMoreLinkText: 'Saznajte više o tome kako koristimo kolačiće',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Upravljanje kolačićima',
      acceptAll: 'Prihvati sve kolačiće',
      manageTitle: 'Upravljaj željenim postavkama saglasnosti',
      necessaryCookiesTitle: 'Neophodni kolačići',
      necessaryCookiesBody:
        'Ovi kolačići su neophodni za funkcionisanje sajta i ne mogu se isključiti u našim sistemima.',
      performanceCookiesTitle: 'Kolačići performansi',
      performanceCookiesBody:
        'Ovi kolačići omogućavaju da brojimo posete i izvore saobraćaja tako da možemo da izmerimo i poboljšamo performanse našeg sajta.',
      confirmChoices: 'Potvrdi moje izbore',
      marketingCookiesTitle: 'Marketinški kolačići',
      marketingCookiesBody:
        'Ovi kolačići nam omogućavaju da personalizujemo oglase i izmerimo njihov učinak.',
      functionalCookiesTitle: 'Kolačići funkcionalnosti',
      functionalCookiesBody:
        'Ovi kolačići se koriste za poboljšanje funkcionalnosti sajta. Bez njih, određene funkcionalnosti mogu postati nedostupne. Na primer, to su kolačići usluga veb ćaskanja i željenih postavki korisnika.',
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'Ukloni',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Zabranjeno',
      content: 'Naš server je ljubazno (ali čvrsto) odbio da ispuni zahtev vašeg pregledača. Zapamtite da Recright može da koristi samo jedan uređaj/pregledač (istovremeno).',
      link: 'Početna stranica',
    },

    error404: {
      heading: 'Ovde nema ničega',
      content: 'Tražili smo temeljno, ali nema web stranice sa adresom koju ste tražili. Možda ste pratili nevažeći link ili slučajno uneli pogrešnu adresu.',
      link: 'Početna stranica',
    },

    error410: {
      heading: 'Zatvoreno',
      content: 'Nije moguće pokazati posao zato što je ili zatvoren ili je period za prijavu istekao.',
      link: 'Početna stranica',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Pokretanje...',
      connection_error_hint: 'Nije moguće uspostaviti vezu sa mrežom.\nPokušajte da ponovo učitate stranicu.',
      permission_hint: 'Morate dozvoliti ovom sajtu da koristi vašu veb kameru i mikrofon',
      searching_camera_hint: 'Traženje web kamere...',
      camera_reserved_hint: 'Druga aplikacija ili veb stranica koristi veb kameru. \nZatvorite tu aplikaciju i ponovo učitajte ovu stranicu.',
      camera_reserved_hint_chrome_extra: 'Morate dozvoliti Recright-u da koristi veb kameru u dijalogu ispod adresne trake',
      no_camera_hint: 'Veb kamera nije pronađena.\n',
      no_mic_hint: 'Mikrofon nije pronađen.\n',
      uploading_text: 'Otprema...',
      rtmpt_in_use: 'Ovaj korak ne bi bio potreban da je vaš administrator mreže dozvolio RTMP. Pitajte nas kako.',
      preview_text: 'Veb kamera je u režimu za pregled',
      close_text: 'Zatvori kameru',
      remove_text: 'Ukloni pokušaj',
      noflash_errortext_install: link => `Izgleda da nemate Adobe Flash Player. Potreban vam je flash dodatak da biste snimali video snimke. Preuzmite flash ovde: ${link}`,
      noflash_errortext_enable: link => `Ukoliko ste već instalirali flash, ali još uvek vidite ovu poruku. Pogledajte ovde: ${link}`,
      noflash_errortext_differentbrowser: 'Takođe možete pokušati da koristite pregledač koji podržava HTML5 snimanje. Predlažemo Chrome ili Firefox',
    },

    footer: {
      terms: 'Uslovi',
      license: 'General Terms of Service',
      privacyPolicy: 'Politika privatnosti',
      customSupport: link => `Kontaktirajte sa nama putem adrese ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Kako biste opisali svoj doživljaj intervjua?',
      howWouldYouRateJobAd: 'Kako biste ocenili svoje iskustvo pri prijavi?',
      yourResponseIsAnonymous: 'Vaš odgovor je anoniman.',
      thankYouFeedback: 'Hvala na povratnim informacijama!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Nažalost, tip datoteke nije dozvoljen.',
      isRequired: 'Ovo polje je obavezno',
      isEmail: value => `${value} nije validna adresa e-pošte.`,
      isDate: value => `${value} nije validan datum.`,
      invalidUrl: 'URL je nevažeći',
      singleHireEndError: 'Pojedinačno zapošljavanje nije korišćeno duže od 60 dana',
      isNotTooOldForLive: 'Datum je u prošlosti',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Ime',
      city: 'Rodno mesto',
      email: 'Imejl adresa',
      phone: 'Broj telefona',
      applyForPosition: 'Prijavite se za radno mesto',
      back: 'Nazad',
      continue: 'Nastavi',
      submit: 'Predaj',
      saveForLater: 'Nastavi kasnije',
      namePlaceholder: 'Unesite vaše ime',
      emailPlaceholder: 'Unesite vašu adresu e-pošte',
      phonePlaceholder: 'Unesite vaš telefonski broj',
      cityPlaceholder: 'Unesite vaše mesto prebivališta',
      links: 'Dodajte linkove, na primer vaš LinkedIn profil',
      legendBasicInfo: 'Osnovni podaci',
      legendLinks: 'Linkovi',
      legendAttachments: 'Prilozi',
      legendAdditionalFields: 'Dodatne informacije',
      coverLetter: 'Propratno pismo',
      attachments: 'Prilozi',
      introduction: 'Napišite kratak uvod ovde',
      thankYou: 'Hvala vam.',
      luck: 'Srećno!',
      close: 'Zatvori',
      required: 'Stavke obeležene * zvezdicom su obavezne.',
    },

    jobAdContainer: {
      endTime: date => (date ? `otvori do ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Prijavite se za posao',
    },

    jobAdQuickInterview: {
      back: 'Nazad',
      submit: 'Predaj',
      saveForLater: 'Nastavi kasnije',
      title: 'Brzi video razgovor',
      description: 'Da bismo se što pre upoznali, želeli bismo da odgovorite na naša kratka pitanja. Iskažite svoju ličnost i postarajte se da vaša prijava ima dušu.',
      requiredNote: 'Ovo je samo jedan deo procesa zapošljavanja, i regruter će primiti vašu prijavu tek kada snimite vaš odgovor.',
      reminderNote: 'Možete snimiti vaš odgovor odmah ili nastaviti kasnije preko podsetnika poslatog e-poštom.',
    },

    jobAdRow: {
      responses: 'Prijave',
      status: {
        open: 'Otvoreno',
        filled: 'Popunjeno',
        cancelled: 'Otkazano',
        done: 'Zatvoreno',
        close: 'Zatvori',
        draft: 'Zatvoreno (radna verzija)',
        hidden: 'Sakriveno',
      },
    },

    interviewRow: {
      responses: 'Kandidati',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Prikaži profil na LinkedInu',
    },

    linkedInButton: {
      error: 'Greška pri povezivanju s vašim profilom. Pokušajte ponovo.',
      buttonText: 'Prijavite se putem usluge LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Možete iskoristiti svoj profil na LinkedInu da biste automatski popunili prijavni formular',
      linkedInOr: 'Ili',
      error: 'Greška pri povezivanju s vašim profilom. Pokušajte ponovo.',
    },

    linkListInput: {
      addField: 'Dodaj',
      removeField: 'Ukloni',
      invalidUrl: 'URL je nevažeći',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        timeIn: partName => `Time in ${partName}:`,
        totalTime: 'Total time in interview:',
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Učitavanje...',
      saving: 'Čuvanje...',
      sending: 'Slanje...',
    },

    modalApplicationForm: {
      applyForPosition: 'Prijavite se za radno mesto',
      continue: 'Nastavi',
      name: 'Unesite vaše ime',
      email: 'Unesite vašu adresu e-pošte',
      phoneNumber: 'Unesite vaš telefonski broj',
      links: 'Možete da unesete linkove',
      legendLinks: 'Linkovi',
      legendAttachments: 'Prilozi',
      coverLetter: 'Propratno pismo',
      attachments: 'Prilozi',
      introduction: 'Napišite vaš uvod ovde',
      thankYou: 'Hvala vam.',
      luck: 'Srećno!',
      close: 'Zatvori',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Javni link koji se može deliti',
      info: 'Evo javne adrese oglasa za posao koju možete da delite.\nSvako ko je zainteresovan za radno mesto može videti oglas za posao i odlučiti da se prijavi.\nPrimićete uobičajeno obaveštenje kada prijave počnu da pristižu.\n\nEvo javnog linka ka oglasu za posao:',
    },

    modalVideoAdd: {
      title: 'Dodajte novi video snimak:',
      chooseTitle: 'Dodajte novi video snimak:',
      titlePlaceholder: 'Unesite naziv video snimka ovde',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Otpremite novi video snimak',
      info: 'Maksimalna dozvoljena veličina video snimka je 500mb. Preporučujemo vam da komprimujete video snimke pre otpreme, tako će otprema i konverzija kraće trajati.',
    },

    modalCandidateInfo: [
      {
        headline: 'Snimite vaš video odgovor ',
        content: 'koliko god puta želite. Video snimci će biti automatski sačuvani odmah posle snimanja i možete se vratiti na video razgovor putem linka koji ste primili e-poštom.',
        mobileContent: 'koliko god puta želite. Dodajte video snimak za razgovor. Videćete kada video snimak bude otpremljen i sačuvan u razgovoru. Možete se vratiti na video razgovor putem linka koji ste primili e-poštom. <br><br><strong>Ako vaš video ekran ostane crn, a koristite Apple mobilni uređaj, uputstva kako da rešite problem ćete pronaći <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">ovde</a>.</strong>',
      },
      {
        headline: 'Posle snimanja, ',
        content: 'proverite da li video radi kako treba i da se vaš glas može jasno čuti. Kada pritisnete „Pošalji“, vaš odgovor će biti zaključan i nećete više moći da ga menjate.',
      },
      {
        headline: 'Kada završite sa razgovorom, ',
        content: 'pritisnite „Pošalji odgovore i završi razgovor“. Posle toga se više ne možete vraćati na video razgovor. Ukoliko želite da zatvorite ovu stranicu i nastavite razgovor kasnije pritisnite „Nastavi kasnije“.',
      },
      {
        headline: 'Ukoliko vam je potrebna pomoć ',
        content: mailto => `pri odgovaranju na pitanja u video razgovoru, kliknite na dugme „pomoć“ u donjem desnom uglu stranice ili na pošaljite e-poruku na ${mailto}.`,
        customContent: link => `Kontaktirajte sa nama putem adrese ${link}`,
      },
    ],

    navigationBar: {
      back: 'Nazad',
      dashboard: 'Kontrolna tabla',
      frontpage: 'Početna stranica',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Broj telefona u formatu ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Prosečna ocena',
      reset: 'resetuj',
    },

    share: {
      share: 'Podeli sa',
      copy: 'Kopiraj link',
    },

    sort: {
      sort: 'Sortiraj',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Odabrano',
      change: 'Promeni',
    },

    video: {
      videoNotFound: 'Vide se obrađuje ili nije nađen',
      retry: 'Pokušajte ponovo',
      originalLanguageLabel: 'Original',
      englishLanguageLabel: 'Engleski',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Otpremite ili snimite novi video snimak' : 'Odaberite fajl'),
      videoPlaceholder: 'Snimite vaš odgovor',
      uploadPlaceholderCandidate: 'Otpremi video snimak',
      submit: 'Predajte vaš odgovor',
      notAnswered: 'Još niste odgovorili',
      remove: 'Ukloni pokušaj',
      converting: 'Video snimak se konvertuje. Sačekajte...',
      uploading: 'Video snimak se otprema. Sačekajte...',
      error: {
        invalid: 'Odabrani fajl je preveliki. Odaberite drugi fajl.',
        upload: 'Izvinjavamo se ali nismo uspeli da otpremimo video snimak. Pokušajte ponovo.',
        transcode: 'Odabrani fajl je oštećen ili je nevažeći, pokušajte ponovo.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Prikaži više',
      showLessButtonText: 'Prikaži manje',
      infoText1:
        'Ostavite karticu da bude aktivna u pozadini dok traje snimanje. Dok snimate ne treba da koristite nijednu drugu aplikaciju.',
      infoText2:
        'Video-zapisi sa pozadinom najbolje funkcionišu u najnovijim pregledačima i sa uređajem koji je relativno nov i moćan.',
      infoText3:
        'Proverite da li druge aplikacije ne koriste mikrofon ili kameru.',
    },

    videoResponse: {
      videoPlaceholder: 'Snimite vaš odgovor',
      uploadPlaceholder: 'Otpremi video snimak',
      submit: 'Predajte vaš odgovor',
      notAnswered: 'Niste odgovorili',
      required: 'Ovo pitanje zahteva odgovor',
      startInterview: 'Započnite razgovor',
    },

    webcam: {
      useVideoBgButtonText: 'Koristi pozadinu video-zapisa ',
      removeVideoBgButtonText: 'Ukloni pozadinu video-zapisa',
      starting: 'Počinje...',
      close: 'Zatvori kameru',
      remove: 'Ukloni pokušaj',
      record: 'Snimaj',
      stop: 'Prekini',
      retake: 'Ponovni pokušaj',
      submit: 'Predajte vaš odgovor',
      converting: 'Video snimak se konvertuje. Sačekajte...',
      uploading: 'Video snimak se otprema. Sačekajte...',
      downloading: 'Video snimak se preuzima. Sačekajte...',
      processing: 'Obrada...',
      uploadInProgress: 'Prenos video snimka je još uvek u toku, nemojte zatvarati pregledač ili menjati stranicu.',
      uploaded: 'Vide je prenet.',
      error: {
        DevicesNotFoundError: 'Kamera ili mikrofon se ne mogu koristiti. Proverite da li je njihovo korišćenje omogućeno.',
        NotFoundError: 'Kamera ili mikrofon se ne mogu koristiti. Proverite da li je njihovo korišćenje omogućeno.',
        NotAllowedError: 'Niste dozvolili korišćenje kamere ili mikrofona.',
        PermissionDismissedError: 'Odbacili ste dijalog za dozvolu. Dozvolite korišćenje kamere i mikrofona.',
        PermissionDeniedError: 'Odbili ste pristup kameri i mikrofonu.',
        NotReadableError: 'Nije moguće videti signal kamere ili mikrofona. Moguć je kvar opreme.',
        SecurityError: 'Nije moguće korišćenje kamere ili mikrofona zbog bezbednosne greške',
        stream: 'Desila se greška. Ponovo pokrenite pregledač. Ako problem nastavi da se javlja, pokušajte sa drugim pregledačem.',
        download: 'Preuzimanje video snimka nije uspelo. Želite li da pokušate ponovo?',
        upload: 'Otpremanje video snimka nije uspelo. Želite li da pokušate ponovo?',
        emptyBlob: 'Memorija vašeg pregledača ili uređaja je puna i ne može da izgradi snimak. Osvežite stranicu i ako to ne pomogne ponovo pokrenite pregledač. Ako problem nastavi da se javlja, pokušajte sa drugim pregledačem.',
        alternativeRecorder: 'Datoteku možete otpremiti i klikom na ovo.',
        reconnecting: 'Veza je prekinuta. Pokušajte da se ponovo povežete.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Zdravo! Pozivamo te na video-intervju ${title}! Ovu pozivnicu smo ti poslali i mejlom `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
